/* Rutland Catalog theme scripts. Plain JS, no dependencies. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } }
  };

  window.rrMoney = (cents) => {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  let toastTimer;
  window.rrToast = (text) => {
    const el = $('#rr-toast');
    if (!el) return;
    el.textContent = text;
    el.hidden = true;
    void el.offsetWidth;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3200);
  };

  /* Mobile menu */
  function initMenu() {
    const btn = $('#rr-menubtn');
    const nav = $('#rr-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const open = nav.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(open));
    });
  }

  /* Parts by hull tabs */
  function initHullTabs(root) {
    const tabs = $$('[data-hull]', root);
    const cards = $$('[data-hulls]', root);
    const showing = $('[data-showing]', root);
    const saved = $('[data-saved]', root);
    if (!tabs.length) return;

    const fits = (card, hull) => {
      if (hull === 'all') return true;
      const list = (card.dataset.hulls || '').split(' ');
      return list.includes('all') || list.includes(hull);
    };

    function apply(hull) {
      let n = 0;
      cards.forEach((c) => {
        const on = fits(c, hull);
        c.hidden = !on;
        if (on) n += 1;
      });
      tabs.forEach((t) => t.setAttribute('aria-pressed', String(t.dataset.hull === hull)));
      const tab = tabs.find((t) => t.dataset.hull === hull);
      if (showing) {
        showing.textContent = hull === 'all'
          ? `Showing all ${n} parts`
          : `Showing ${n} parts that fit the ${tab ? tab.dataset.label : hull}`;
      }
      if (saved) saved.textContent = hull === 'all' ? 'Pick a hull to filter' : 'Your ski is saved on this device';
    }

    tabs.forEach((t) => t.addEventListener('click', () => {
      store.set('rr-hull', t.dataset.hull);
      apply(t.dataset.hull);
    }));

    const remembered = store.get('rr-hull');
    const start = tabs.some((t) => t.dataset.hull === remembered) ? remembered : (root.dataset.defaultHull || 'all');
    apply(start);
  }

  /* Quantity steppers */
  function initQty(root = document) {
    $$('[data-qty]', root).forEach((wrap) => {
      if (wrap.dataset.bound) return;
      wrap.dataset.bound = '1';
      const input = $('input', wrap);
      $$('button', wrap).forEach((b) => b.addEventListener('click', () => {
        const min = Number(input.min || 0);
        const max = input.max ? Number(input.max) : 9999;
        const next = Math.min(max, Math.max(min, (Number(input.value) || 0) + Number(b.dataset.step)));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
    });
  }

  /* Product gallery thumbnails */
  function initGallery(root = document) {
    $$('[data-gallery]', root).forEach((g) => {
      const main = $('[data-gallery-main]', g);
      $$('[data-thumb]', g).forEach((b) => b.addEventListener('click', () => {
        main.src = b.dataset.src;
        main.srcset = b.dataset.srcset || '';
        main.alt = b.dataset.alt || '';
        $$('[data-thumb]', g).forEach((x) => x.setAttribute('aria-current', String(x === b)));
      }));
    });
  }
  window.rrShowMedia = (mediaId) => {
    const b = document.querySelector(`[data-thumb][data-media-id="${mediaId}"]`);
    if (b) b.click();
  };

  /* Variant picker for the standard product form */
  function initVariantPicker(root = document) {
    $$('[data-variant-picker]', root).forEach((picker) => {
      const dataEl = $('script[type="application/json"]', picker);
      if (!dataEl) return;
      const variants = JSON.parse(dataEl.textContent);
      const form = document.getElementById(picker.dataset.form);
      const idInput = form && $('input[name="id"]', form);
      const sectionId = picker.dataset.section;
      const priceBox = document.getElementById(`price-${sectionId}`);
      const button = form && $('[data-add-button]', form);
      const stock = document.getElementById(`stock-${sectionId}`);
      const sku = document.getElementById(`sku-${sectionId}`);

      function selected() {
        return $$('fieldset', picker).map((fs) => {
          const c = $('input:checked', fs);
          return c ? c.value : null;
        });
      }

      function update() {
        const opts = selected();
        const v = variants.find((x) => x.options.every((o, i) => o === opts[i]));
        if (!v) {
          if (button) { button.disabled = true; button.textContent = 'Not available'; }
          return;
        }
        if (idInput) idInput.value = v.id;
        if (button) {
          button.disabled = !v.available;
          button.textContent = v.available ? 'Add to cart' : 'Sold out';
        }
        if (priceBox) {
          const p = $('.price', priceBox);
          if (p) {
            const onSale = v.compare_at_price && v.compare_at_price > v.price;
            p.classList.toggle('price--on-sale', !!onSale);
            p.classList.toggle('price--sold-out', !v.available);
            const reg = $('.price__regular .price-item--regular', p);
            const sale = $('.price__sale .price-item--sale', p);
            const cmp = $('.price__sale .price-item--regular', p);
            if (reg) reg.textContent = window.rrMoney(v.price);
            if (sale) sale.textContent = window.rrMoney(v.price);
            if (cmp) cmp.textContent = window.rrMoney(v.compare_at_price || 0);
          }
        }
        if (stock) {
          stock.className = 'stock ' + (v.available ? 'stock--in' : 'stock--out');
          stock.textContent = v.available ? 'In stock, ships in ' + (stock.dataset.lead || '1–2 days') : 'Out of stock';
        }
        if (sku) sku.textContent = v.sku ? 'Part no. ' + v.sku : '';
        if (v.featured_media && v.featured_media.id) window.rrShowMedia(v.featured_media.id);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
        if (form) form.dispatchEvent(new Event('change', { bubbles: true }));
      }

      picker.addEventListener('change', update);
    });
  }

  /* Cart page: quantity changes submit the form */
  function initCart() {
    const form = $('#rr-cart-form');
    if (!form) return;
    let t;
    form.addEventListener('change', (e) => {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(() => form.requestSubmit ? form.requestSubmit($('[name="update"]', form)) : form.submit(), 500);
    });
  }

  /* Simple add-to-cart buttons on product cards (single-variant products) */
  function initQuickAdd() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-quick-add]');
      if (!form) return;
      e.preventDefault();
      const btn = $('button[type="submit"]', form);
      if (btn) btn.disabled = true;
      try {
        const res = await fetch(`${window.rrRoutes.cartAdd}.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart.');
        const cart = await (await fetch(`${window.rrRoutes.cart}.js`)).json();
        $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        window.rrToast(`Added to cart: ${json.product_title || json.title}`);
      } catch (err) {
        window.rrToast(err.message);
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  }

  function init(root = document) {
    initQty(root);
    initGallery(root);
    initVariantPicker(root);
    $$('[data-hull-tabs]', root).forEach(initHullTabs);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initCart();
    initQuickAdd();
    init();
  });
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
